(() => {
  'use strict';

  const ready = (fn) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();

  ready(() => {
    if (!document.body.classList.contains('template-collection')) return;

    let live = document.getElementById('collection-wcag-status');
    if (!live) {
      live = document.createElement('div');
      live.id = 'collection-wcag-status';
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      document.body.appendChild(live);
    }

    const announce = (message) => {
      live.textContent = '';
      window.setTimeout(() => { live.textContent = message; }, 40);
    };

    const repairCollection = (root = document) => {
      /* The permanent desktop sidebar is not a modal dialog. */
      root.querySelectorAll('.grid__item--sidebar[role="dialog"]').forEach((sidebar) => {
        sidebar.removeAttribute('role');
        sidebar.removeAttribute('aria-modal');
        sidebar.setAttribute('aria-label', 'Filter products');
      });

      root.querySelectorAll('.filter-form').forEach((form) => {
        form.setAttribute('aria-label', 'Filter products');
      });

      /* Expose disclosure state for every filter group. */
      root.querySelectorAll('.collection-sidebar__group .collapsible-trigger[aria-controls]').forEach((button) => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const expanded = button.classList.contains('is-open') || panel?.classList.contains('is-open');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (!button.getAttribute('aria-label')) {
          button.setAttribute('aria-label', `${expanded ? 'Collapse' : 'Expand'} ${button.textContent.trim()}`);
        }
      });

      /* Fix duplicate filter control IDs generated in sidebar and drawer copies. */
      const seen = new Set();
      root.querySelectorAll('.filter-form input[id]').forEach((input, index) => {
        const original = input.id;
        if (!seen.has(original)) {
          seen.add(original);
          return;
        }
        const replacement = `${original}-wcag-${index + 1}`;
        const label = input.closest('label') || root.querySelector(`label[for="${CSS.escape(original)}"]`);
        input.id = replacement;
        if (label) label.setAttribute('for', replacement);
      });

      /* Active filters need an action-oriented accessible name. */
      root.querySelectorAll('.tag--remove a').forEach((link) => {
        const value = link.textContent.trim();
        link.setAttribute('aria-label', `Remove filter: ${value}`);
      });

      const filterDrawerButton = root.querySelector('.js-drawer-open-collection-filters');
      const filterDrawer = document.getElementById('FilterDrawer');
      if (filterDrawerButton) {
        filterDrawerButton.setAttribute('aria-expanded', filterDrawer?.classList.contains('drawer--is-open') ? 'true' : 'false');
        filterDrawerButton.setAttribute('aria-haspopup', 'dialog');
      }
      if (filterDrawer) {
        filterDrawer.setAttribute('role', 'dialog');
        filterDrawer.setAttribute('aria-modal', 'true');
        filterDrawer.setAttribute('aria-label', 'Product filters');
      }

      /* Ensure sorting has an understandable name and announces changes. */
      const sort = root.querySelector('#SortBy');
      if (sort) {
        sort.setAttribute('aria-label', 'Sort products');
        if (!sort.dataset.wcagBound) {
          sort.dataset.wcagBound = 'true';
          sort.addEventListener('change', () => {
            const label = sort.options[sort.selectedIndex]?.textContent.trim();
            announce(`Products sorted by ${label}.`);
          });
        }
      }

      /* Price inputs need explicit names even though the custom slider controls them. */
      root.querySelectorAll('.price-range__input-min').forEach((input) => {
        input.setAttribute('aria-label', 'Minimum price');
        input.setAttribute('inputmode', 'decimal');
      });
      root.querySelectorAll('.price-range__input-max').forEach((input) => {
        input.setAttribute('aria-label', 'Maximum price');
        input.setAttribute('inputmode', 'decimal');
      });

      /* Product grid and results count. */
      const grid = root.querySelector('.collection-grid__wrapper .grid.grid--uniform');
      const count = root.querySelector('.collection-filter__item--count')?.textContent.trim();
      if (grid) {
        grid.setAttribute('role', 'region');
        grid.setAttribute('aria-label', count ? `Product results: ${count}` : 'Product results');
      }

      /* Improve image alternatives where catalog media alt text is absent. */
      root.querySelectorAll('.grid-product').forEach((card) => {
        const title = card.querySelector('.grid-product__title')?.textContent.trim();
        if (!title) return;
        card.querySelectorAll('img').forEach((image, index) => {
          const alt = image.getAttribute('alt')?.trim();
          if (!alt || alt.toLowerCase() === 'image') {
            image.setAttribute('alt', index === 0 ? title : `${title}, alternate view ${index + 1}`);
          }
        });

     /* Wishlist controls: give app-generated divs proper button semantics. */
card.querySelectorAll(
  '.th_wl_button, .th_wl_button_after, .th_wl_col_btn button, [class*="th_wl"] button'
).forEach((wishlist) => {

  /* The wishlist app sometimes generates a DIV instead of a real button. */
  if (wishlist.tagName !== 'BUTTON') {
    wishlist.setAttribute('role', 'button');
    wishlist.setAttribute('tabindex', '0');
  }

  /* Give the control an accessible name. */
  if (!wishlist.getAttribute('aria-label')) {
    wishlist.setAttribute('aria-label', `Add ${title} to wishlist`);
  }

  /* Make DIV-based wishlist controls operable by keyboard. */
  if (
    wishlist.tagName !== 'BUTTON' &&
    !wishlist.dataset.wcagKeyboardBound
  ) {
    wishlist.dataset.wcagKeyboardBound = 'true';

    wishlist.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        wishlist.click();
      }
    });
  }
});

        const quick = card.querySelector('.quick-product__btn');
        if (quick) {
          quick.removeAttribute('role');
          quick.removeAttribute('aria-modal');
          quick.setAttribute('type', 'button');
          quick.setAttribute('aria-haspopup', 'dialog');
          quick.setAttribute('aria-label', `Quick view: ${title}`);
        }

        card.querySelectorAll('.grid-product__tag--sale').forEach((tag) => tag.setAttribute('aria-label', `${title} is on sale`));
        card.querySelectorAll('.grid-product__tag--sold-out').forEach((tag) => tag.setAttribute('aria-label', `${title} is sold out`));
      });
    };

    repairCollection();

    document.addEventListener('click', (event) => {
      const disclosure = event.target.closest('.collection-sidebar__group .collapsible-trigger[aria-controls]');
      if (disclosure) {
        window.setTimeout(() => {
          const panel = document.getElementById(disclosure.getAttribute('aria-controls'));
          const expanded = disclosure.classList.contains('is-open') || panel?.classList.contains('is-open');
          disclosure.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          disclosure.setAttribute('aria-label', `${expanded ? 'Collapse' : 'Expand'} ${disclosure.textContent.trim()}`);
        }, 0);
      }
    });

    const ajax = document.getElementById('CollectionAjaxContent');
    if (ajax) {
      const observer = new MutationObserver(() => {
        repairCollection(ajax);
        const count = ajax.querySelector('.collection-filter__item--count')?.textContent.trim();
        if (count) announce(`Product results updated. ${count}.`);
      });
      observer.observe(ajax, { childList: true, subtree: true });
    }

    const drawer = document.getElementById('FilterDrawer');
    const drawerButton = document.querySelector('.js-drawer-open-collection-filters');
    if (drawer && drawerButton) {
      const observer = new MutationObserver(() => {
        const open = drawer.classList.contains('drawer--is-open') || document.body.classList.contains('js-drawer-open');
        drawerButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();
